// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarPlUtilizado,
  getPlUtilizadoSelecionado,
  getPlsUtilizadoDisponiveis,
} from "../../../../state";

export default function SelecaoPlUtilizado() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao="ConfiguracaoIndicador.plUtilizado"
        itensSelector={getPlsUtilizadoDisponiveis}
        selectorItemSelecionado={getPlUtilizadoSelecionado}
        onItemChange={selecionarPlUtilizado}
        campoId="codigo"
        campoChaveTraducao="descricao"
      />
    </div>
  );
}
